document.addEventListener('DOMContentLoaded',()=>{
  const triggers=document.querySelectorAll('.js-accordion-trigger, .js-collapsible-region-trigger');
  triggers.forEach(trigger=>{
    const content=document.getElementById(trigger.getAttribute('aria-controls'));
    const plus=trigger.querySelector('.accordion__icon--plus, .collapsible__icon--plus');
    const minus=trigger.querySelector('.accordion__icon--minus, .collapsible__icon--minus');
    const setState=()=>{
      const expanded=trigger.getAttribute('aria-expanded')==='true';
      if(expanded){
        trigger.classList.add('open');
        if(plus) plus.style.display='none';
        if(minus) minus.style.display='block';
      }else{
        trigger.classList.remove('open');
        if(plus) plus.style.display='block';
        if(minus) minus.style.display='none';
      }
    };
    setState();
    trigger.addEventListener('click',()=>{
      const previousTop=trigger.getBoundingClientRect().top;
      setTimeout(()=>{
        const expanded=trigger.getAttribute('aria-expanded')==='true';
        if(expanded){
          triggers.forEach(other=>{
            if(other!==trigger && other.getAttribute('aria-expanded')==='true'){
              other.click();
            }
          });
        }
        setState();
        const newTop=trigger.getBoundingClientRect().top;
        const delta=newTop-previousTop;
        if(delta!==0){
          window.scrollBy({top:delta});
        }
      },0);
    });
  });
});
